import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'
import { FC, ReactNode, useId, useState } from 'react'
import {
  RuleSwitch,
  RuleSwitchRow,
} from '../editResponseFormulaRule/NormalValueRow.styled'
import { QuestionAutocomplete } from './QuestionAutocomplete'

type Props = {
  nodes: TemplateNodeSchema[]
  value?: string
  onChange: (value: string | undefined) => void
  toggleLabel: string
  autocompleteLabel: string
  autocompletePlaceholder: string
  autocompleteDescription?: ReactNode
}

export const SelectQuestionWithToggle: FC<Props> = ({
  nodes,
  value,
  onChange,
  toggleLabel,
  autocompleteLabel,
  autocompletePlaceholder,
  autocompleteDescription,
}) => {
  const toggleId = useId()

  const [isActive, setIsActive] = useState(!!value)

  const onSwitchDeactivate = () => {
    setIsActive(false)
    onChange(undefined)
  }

  const handleSwitchChange = (checked: boolean) => {
    if (checked) {
      setIsActive(true)
      return
    }
    // checked が false の場合はルールを無効にした時のハンドラを呼び出す
    onSwitchDeactivate()
  }

  const handleSelectChange = (uuid: string | undefined) => {
    onChange(uuid)
  }

  return (
    <div>
      <RuleSwitchRow>
        <RuleSwitch
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          checked={isActive}
          onChange={handleSwitchChange}
          aria-labelledby={toggleId}
        />
        <label id={toggleId}>{toggleLabel}</label>
      </RuleSwitchRow>

      {isActive && (
        <QuestionAutocomplete
          selectedQuestionId={value}
          onChange={handleSelectChange}
          nodes={nodes}
          label={autocompleteLabel}
          placeholder={autocompletePlaceholder}
          description={autocompleteDescription}
        />
      )}
    </div>
  )
}
